import {TextInput} from '@mantine/core';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import type {ReactNode} from 'react';
import {useState} from 'react';
import {Button} from 'src/design/atoms/Button';

interface TotpCodeFormProps {
  /** Resolve `false` to keep the entered code after a handled failure. */
  onSubmit: (code: string) => Promise<unknown>;
  loading?: boolean;
  label?: string;
  error?: string;
  autoFocus?: boolean;
  /** Rendered beside the submit button, e.g. Cancel. */
  secondaryActions?: ReactNode;
}

const isComplete = (code: string) => /^\d{6}$/.test(code);

export const TotpCodeForm = ({
  onSubmit,
  loading,
  label = 'Verify code',
  error,
  autoFocus = false,
  secondaryActions,
}: TotpCodeFormProps) => {
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  return (
    <form
      onSubmit={async event => {
        event.preventDefault();
        if (submitting || loading || !isComplete(code)) return;
        setSubmitting(true);
        try {
          if ((await onSubmit(code)) !== false) setCode('');
        } finally {
          setSubmitting(false);
        }
      }}>
      <Stack>
        <TextInput
          label="6-digit code"
          placeholder="123456"
          value={code}
          error={error}
          onChange={event =>
            setCode(event.currentTarget.value.replace(/\D/g, '').slice(0, 6))
          }
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9]{6}"
          maxLength={6}
          required
          autoFocus={autoFocus}
        />
        <Group>
          <Button
            type="submit"
            loading={loading || submitting}
            disabled={!isComplete(code)}>
            {label}
          </Button>
          {secondaryActions}
        </Group>
      </Stack>
    </form>
  );
};
